import Model, { attr } from '@ember-data/model';
import { type LineItemCustomPropertyInfo } from './fund-setting';

export default class TransactionFilterOptionModel extends Model {
  @attr() transTypes!: string[];
  @attr() customProperties!: LineItemCustomPropertyInfo[]; // TODO: this should be removed because it's now coming from FundSettingModel
  @attr('boolean') hasAnonymous!: boolean;
}
